function phoneNumberFormat(id) {
	var n = document.getElementById(id);

	if(n) {
		var val = n.value;

		var n_str = n.value.replace(/[^\d\+]/g,"");

		var n_len = n_str.length;
		var n_value = "";
		for(var i = 0; i < n_len; i++) {
			if(i == 3 || i == 6) {
				n_value += "-";
			}
			var cur_elt = n_str[i];
			n_value += cur_elt;
		}

		n.value = n_value;
	}
}